import type { DragEvent } from "react";

import type { MentionCandidate } from "../hooks/useMentionCandidates";

/** The drag type of an application's document dragged from its page into the chat. */
export const DOCUMENT_DRAG_TYPE = "application/x-steddy-document";

export type DraggedDocument = Extract<MentionCandidate, { kind: "document" }>;

/** What a drag carries that the chat takes: an application's document, or files. */
export type DragKind = "document" | "files";

export function dragKindOf(types: readonly string[]): DragKind | null {
  if (types.includes(DOCUMENT_DRAG_TYPE)) return "document";
  return types.includes("Files") ? "files" : null;
}

// A drag's data is unreadable until the drop, but the drop area names the file while it is over:
// the page that started the drag (this window) remembers it here.
let dragged: DraggedDocument | null = null;

/** Call from a document row's onDragStart; the chat's drop area takes it. */
export function startDocumentDrag(event: DragEvent, document: DraggedDocument) {
  dragged = document;
  event.dataTransfer.effectAllowed = "copy";
  event.dataTransfer.setData(DOCUMENT_DRAG_TYPE, String(document.id));
  event.dataTransfer.setData("text/plain", document.name);
}

/** Call from the row's onDragEnd. */
export function endDocumentDrag() {
  dragged = null;
}

export function draggedDocument(): DraggedDocument | null {
  return dragged;
}
